const SETTINGS = {
  DEBUG: false,
  HOST: '',
  COOKIE_COUNTRY_CODE_NAME: '',
  COOKIE_COUNTRY_CODE_OPTIONS: {},
  COOKIE_ALLOW_COOKIES_NAME: '',
  COOKIE_ALLOW_COOKIES_OPTIONS: {},
};

export default SETTINGS;
